// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3aA7g","row":"ProcedureTreatmentSummary_row__20Lig"};